export default __webpack_public_path__ + "images/c2741fc2b299f51e50afa797f3e51aa8-san_diego_mobile.webp";